// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ubKk9","head":"Table_head__30s2a","col":"Table_col__3gw9T"};